// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Skeleton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/skeleton/Skeleton.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as CheckBoxGroup$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/check-box-group/CheckBoxGroup.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormInputHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInputHelper.bs.js";
import * as FormCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormCheckBoxInput.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function isCommentRequired(categorized_issues, selected_issues) {
  var allIssues = Belt_List.flatten(Belt_List.map(categorized_issues.categories, (function (c) {
              return c.issues;
            })));
  return Belt_List.some(selected_issues, (function (issue) {
                return Belt_List.some(allIssues, (function (i) {
                              if (i.issue_name === issue) {
                                return i.issue_comment_required;
                              } else {
                                return false;
                              }
                            }));
              }));
}

var validators = {
  selectedIssues: {
    strategy: /* OnFirstSuccessOrFirstBlur */3,
    validate: (function (param) {
        var selectedIssues = param.selectedIssues;
        var match = Belt_List.length(selectedIssues);
        if (match !== 0) {
          return {
                  TAG: /* Ok */0,
                  _0: selectedIssues
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please select issue"
                };
        }
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          selectedIssues: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            selectedIssues: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.selectedIssues;
  var match$1 = match ? match._0 : Curry._1(validators.selectedIssues.validate, input);
  if (match$1.TAG === /* Ok */0) {
    return {
            TAG: /* Valid */0,
            output: {
              selectedIssues: match$1._0
            },
            fieldsStatuses: {
              selectedIssues: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: /* Invalid */1,
            fieldsStatuses: {
              selectedIssues: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSelectedIssuesField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.selectedIssues, validators.selectedIssues, (function (status) {
                          return {
                                  selectedIssues: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */1 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */1,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */2,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */4);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */3);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */2 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */3 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */4 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSelectedIssuesField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.selectedIssues, state.submissionStatus, validators.selectedIssues, (function (status) {
                                    return {
                                            selectedIssues: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */1 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                selectedIssues: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                selectedIssues: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */2 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */3 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSelectedIssues: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSelectedIssuesField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSelectedIssues: (function (param) {
              return Curry._1(dispatch, /* BlurSelectedIssuesField */0);
            }),
          selectedIssuesResult: Formality.exposeFieldResult(state.fieldsStatuses.selectedIssues),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.selectedIssues) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */1);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */2);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */3);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */3,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */4);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialInput(data) {
  return {
          selectedIssues: data.selected_issue
        };
}

function IssueSectionV2(Props) {
  var form = Props.form;
  var categorized_issues = Props.categorized_issues;
  var hasOrderStage = Props.hasOrderStage;
  var onRetry = Props.onRetry;
  var tmp;
  var exit = 0;
  if (hasOrderStage) {
    if (typeof categorized_issues === "number") {
      exit = 1;
    } else {
      switch (categorized_issues.TAG | 0) {
        case /* Loading */0 :
            exit = 1;
            break;
        case /* Live */1 :
            var data = categorized_issues._0;
            tmp = Belt_List.length(data.categories) === 0 ? React.createElement("div", {
                    className: "raise-ticket-v2-empty-state"
                  }, "No issues are configured for this Order Stage. Try changing your selection.") : React.createElement(React.Fragment, undefined, Belt_List.toArray(Belt_List.map(data.categories, (function (category) {
                              return React.createElement("div", {
                                          key: String(category.category_id)
                                        }, React.createElement("label", {
                                              className: "raise-ticket-v2-category-title"
                                            }, category.category_name), React.createElement(FormCheckBoxInput$Catalyst.make, {
                                              input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                                      var issueName = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                                      return Curry._2(form.updateSelectedIssues, (function (param, v) {
                                                                    return {
                                                                            selectedIssues: v
                                                                          };
                                                                  }), CheckBoxGroup$Catalyst.isChecked(form.input.selectedIssues, issueName) ? Belt_List.keep(form.input.selectedIssues, (function (a) {
                                                                          return a !== issueName;
                                                                        })) : ({
                                                                      hd: issueName,
                                                                      tl: form.input.selectedIssues
                                                                    }));
                                                    }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "raise-ticket-form-input-container", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                              checkbox_props: {
                                                selected: form.input.selectedIssues,
                                                options: Belt_List.map(category.issues, (function (issue) {
                                                        return {
                                                                id: issue.issue_name,
                                                                label: issue.issue_comment_required ? issue.issue_name + " *" : issue.issue_name,
                                                                value: issue.issue_name
                                                              };
                                                      })),
                                                row_layout: true
                                              }
                                            }));
                            }))), React.createElement("div", {
                        className: "raise-ticket-v2-issue-error"
                      }, FormInputHelper$Catalyst.getWarningOrError(undefined, form.selectedIssuesResult, /* NoText */0)));
            break;
        case /* Error */2 :
            tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: categorized_issues._0,
                  refreshView: onRetry,
                  refreshText: "Retry"
                });
            break;
        
      }
    }
  } else {
    tmp = React.createElement("div", {
          className: "raise-ticket-v2-empty-state"
        }, "Please select an Order Stage to view available issues.");
  }
  if (exit === 1) {
    tmp = React.createElement("div", {
          className: "raise-ticket-v2-shimmer"
        }, React.createElement(Skeleton$Catalyst.make, {
              variant: /* Rectangle */2,
              width: "100%",
              height: "24px"
            }), React.createElement(Skeleton$Catalyst.make, {
              variant: /* Rectangle */2,
              width: "100%",
              height: "80px"
            }), React.createElement(Skeleton$Catalyst.make, {
              variant: /* Rectangle */2,
              width: "100%",
              height: "80px"
            }));
  }
  return React.createElement("div", {
              className: "c-raise-ticket-issue-section-v2"
            }, React.createElement("label", {
                  className: "raise-ticket-v2-section-title"
                }, "Issues"), tmp);
}

var make = IssueSectionV2;

export {
  isCommentRequired ,
  Form ,
  getInitialInput ,
  make ,
  
}
/* react Not a pure module */
